import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { chooseEventTypeModalCall, navCalendarItems } from './CalendarPage';
import './NavigationStyles.scss';
import { ReactComponent as PlusIcon } from '../../assets/icons/plus.svg';
import { BREAKPOINT_LG } from '../../consts';
import { Button, SegmentedButton } from '@iba-team/portal-react-components/dist';
import { observer } from 'mobx-react';
import { SpecialDay } from '../../types';
import { useAnalytics, useCheckAccess, useDeviceSizeThreshold, useIsMobile } from '../../utils/hooks';

interface NavButtons {
  activeTable: string,
  setActiveTable: (value: string) => void,
  dataSource: ReadonlyArray<SpecialDay>,
  setDataSource: (data: SpecialDay[])=> void
}

export const NavigationButtons = observer((props: NavButtons ) => {
  const { activeTable, setActiveTable } = props;
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const isTablet = useDeviceSizeThreshold(BREAKPOINT_LG);
  const {isAllowedAccess} = useCheckAccess('CALENDAR_ADMIN');
  return (
    <div className={'table_header_right'}>
      <div className={'navButtons'}>
        <SegmentedButton actionList={!isMobile ? navCalendarItems: navCalendarItems.filter(key => key.value !== 'Month')} theme={{variant: 'neutral', color: 'grey'}} activeItem={activeTable} setActiveItem={(item) => {
          useAnalytics('Calendar', 'calendar_view', item);
          setActiveTable(item);
        }}/>

      </div>
      {!isTablet && isAllowedAccess &&  <Button theme={{variant: 'primary', color: 'theme'}}
        className={'new_event_btn'}
        icon={<PlusIcon />}
        data-testid={'newEventBtn'}
        onClick={() => chooseEventTypeModalCall.showImmediately({specialDays: null, dataSource: props.dataSource, setDataSource: props.setDataSource})}>
        { t('newEvent') }
      </Button>}
    </div>
  );
});
